// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Tab UX CSS Classes
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
.ezTabContainer {
  color: var(--ezFontColor);
  background-color: var(--ezClockerWhite);
  border-style: none;
  padding: 4px;
}

.ezTabsContainer {
  padding-top: 4px;
  padding-left: 4px;
  padding-right: 4px;
  padding-bottom: 0;
  /* --ezClockerBackground defined in ez-body.css */
  background-color: var(--ezClockerBackground);
  /* --ezClockerGray defined in ez-body.css */
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-top-width: 1px;
  border-bottom-width: 0;
  border-left-width: 1px;
  border-right-width: 1px;
}

.ezTabs-tab-button,
.ezTabs-tab-button:enabled {
  margin: 0 4px 0 0;
  min-height: 32;
  border-style: solid;
  border-width: 1px;
  border-color: #000000;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  background-color: #c0c0c0;
  outline-style: none;
  color: #000000;
  box-shadow: none;
}

.ezTabs-tab-button:hover {
  background-color: #e0e0e0;
  box-shadow: none;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  outline-style: none;
}

.ezTabs-tab-button:active {
  background-color: #ffffff;
  border-bottom-width: 2px;
  border-bottom-color: #ffffff;
  box-shadow: none;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  outline-style: none;
}

.ezTabs-tab-button:focus,
.ezTabs-tab-button:focus:active {
  box-shadow: none;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  outline-style: none;
}

.ezTabs-tab-button-active {
  margin: 0 4px 0 0;
  min-height: 32;
  font-weight: bold;
  border-style: solid;
  border-width: 1px;
  border-color: #6d6e70;
  border-bottom-color: #ffffff;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  outline-style: none;
  color: #000000;
  background-color: #ffffff;
  box-shadow: none;
}

.ezTabs-tab-button-active:HOVER {
  border-style: solid;
  border-width: 1px;
  border-color: #6d6e70;
  border-bottom-color: #ffffff;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  outline-style: none;
  color: #000000;
  background-color: #ffffff;
  box-shadow: none;
}

.ezTabs-tab-button-active:ACTIVE {
  border-style: solid;
  border-width: 1px;
  border-color: #6d6e70;
  border-bottom-color: #ffffff;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  outline-style: none;
  color: #000000;
  background-color: #ffffff;
  box-shadow: none;
}

.ezTabs-tab-button-active:FOCUS {
  border-style: solid;
  border-width: 1px;
  border-color: #6d6e70;
  border-bottom-color: #ffffff;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  outline-style: none;
  color: #000000;
  background-color: #ffffff;
  box-shadow: none;
}

.ez-tab-view-container {
  border-style: solid;
  border-color: var(--ezClockerBlack);
  border-width: 2px;
}

.ezTabs-tab-view {
  padding: 8px;
  margin: 0;
  /* --ezClockerSilver defined in ez-body.css */
  background-color: var(--ezClockerSilver);
  /* --ezClockerGray defined in ez-body.css */
  border-color: var(--ezClockerGray);
  border-width: 1px;
  border-style: solid;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.ezTabs-tab-view-active {
  padding: 8px;
  margin: 0;
  /* --ezClockerSilver defined in ez-body.css */
  background-color: var(--ezClockerSilver);
  /* --ezClockerGray defined in ez-body.css */
  border-color: var(--ezClockerBlack);
  border-width: 1px;
  border-style: solid;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.ezTabs-tab-view-hidden {
  display: none;
  padding: 8px;
  margin: 0;
  /* --ezClockerSilver defined in ez-body.css */
  background-color: var(--ezClockerSilver);
  /* --ezClockerGray defined in ez-body.css */
  border-color: var(--ezClockerGray);
  border-width: 1px;
  border-style: solid;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.ezTabs-content {
  background-color: transparent;
  border-color: var(--ezClockerBlack);
  border-width: 1px;
  border-style: solid;
}

.ezTabs-content-scroll-box {
  padding: 8px;
  overflow: auto;
  border-style: solid;
  border-width: 1px;
  border-color: var(--ezClockerGray);
  box-shadow: inset 0 0 1px 1px rgb(109 110 112/50%);
}

.ezTabs-section-grid-cols_360x360 {
  margin-top: 10px;
  display: grid;
  grid-template-columns: 360px 360px;
  justify-content: stretch;
  align-content: center;
  grid-column-gap: 16px;
}

.ezTabs-section-grid-cols_75x25 {
  margin-top: 10px;
  display: grid;
  grid-template-columns: 75% auto;
  grid-template-rows: auto;
  justify-content: start;
  align-content: center;
  grid-column-gap: 8px;
  grid-row-gap: 8px;
}

.ezTabs-section-grid-cols_100 {
  margin-top: 10px;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto;
  justify-content: start;
  align-content: start;
  grid-column-gap: 8px;
  grid-row-gap: 8px;
}

.ezTab,
.ezTab:enabled,
.ezTab:visited {
  min-height: 32px;
  margin-bottom: 0;
  color: var(--ezClockerBlack);
  background-color: var(--ezClockerOffWhite);
  border-color: var(--ezLightNavy);
  border-style: solid;
  border-width: 1px;
  border-bottom-width: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  outline-style: none;
  outline-width: 0;
}

.ezTab:enabled:hover,
.ezTab:enabled:active,
.ezTab:enabled:focus {
  margin-bottom: 0;
  color: var(--ezNavyContainerTextColor);
  background-color: var(--ezHoverNavy);
  border-color: var(--ezClockerBlack);
  border-style: solid;
  border-width: 1px;
  border-bottom-width: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  outline-style: none;
  outline-width: 0;
  box-shadow: inset 0 -4px 4px -2px var(--ezDarkNavy);
}

.ezErrorTab,
.ezErrorTab:enabled,
.ezErrorTab:visited {
  min-height: 32;
  margin-bottom: 0;
  color: var(--ezClockerBlack);
  background-color: var(--ezClockerOffWhite);
  border-color: var(--ezBorderAlertRed);
  border-style: solid;
  border-width: 2px;
  border-bottom-width: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  outline-style: none;
  outline-width: 0;
}

.ezErrorTab:enabled:hover,
.ezErrorTab:enabled:active,
.ezErrorTab:enabled:focus {
  margin-bottom: 0;
  color: var(--ezNavyContainerTextColor);
  background-color: var(--ezHoverNavy);
  border-color: var(--ezBorderAlertRed);
  border-style: solid;
  border-width: 2px;
  border-bottom-width: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  outline-style: none;
  outline-width: 0;
  box-shadow: inset 0 -4px 4px -2px var(--ezDarkNavy);
}

.ezActiveTab,
.ezActiveTab:hover,
.ezActiveTab:visited,
.ezActiveTab:focus,
.ezActiveTab:active,
.ezActiveTab:enabled,
.ezActiveTab:enabled:hover,
.ezActiveTab:enabled:visited,
.ezActiveTab:enabled:active,
.ezActiveTab:enabled:active:hover,
.ezActiveTab:enabled:focus,
.ezActiveTab:enabled:focus:hover,
.ezActiveTab:enabled:focus:active,
.ezActiveTab:enabled:focus:active:hover {
  margin-bottom: 0;
  min-height: 32;
  background-color: var(--ezClockerNavy);
  color: var(--ezNavyContainerTextColor);
  font-weight: bold;
  border-color: var(--ezClockerBlack);
  border-style: solid;
  border-width: 1px;
  border-bottom-width: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  outline-style: none;
  box-shadow: 0 -2px 2px 0 rgb(109 110 112/50%), 2px 0 2px 0 rgb(109 110 112/50%), -2px 0 2px 0 rgb(109 110 112/50%);
}

.ezErrorActiveTab,
.ezErrorActiveTab:hover,
.ezErrorActiveTab:visited,
.ezErrorActiveTab:focus,
.ezErrorActiveTab:enabled,
.ezErrorActiveTab:enabled:hover,
.ezErrorActiveTab:enabled:visited,
.ezErrorActiveTab:enabled:active,
.ezErrorActiveTab:enabled:active:hover,
.ezErrorActiveTab:enabled:focus,
.ezErrorActiveTab:enabled:focus:hover,
.ezErrorActiveTab:enabled:focus:active,
.ezErrorActiveTab:enabled:focus:active:hover {
  margin-bottom: 0;
  min-height: 32;
  background-color: var(--ezClockerNavy);
  color: var(--ezNavyContainerTextColor);
  font-weight: bold;
  border-color: var(--ezBorderAlertRed);
  border-style: solid;
  border-width: 2px;
  border-bottom-width: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  outline-style: none;
  box-shadow: 0 -2px 2px 0 rgb(109 110 112/50%), 2px 0 2px 0 rgb(109 110 112/50%), -2px 0 2px 0 rgb(109 110 112/50%);
}

/* -------------------------------------------------------------------
| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 1023px) {
}
*/
/* -------------------------------------------------------------------
| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 768px) {
}
*/
/* -------------------------------------------------------------------
| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 480px) {
}
*/
/* -------------------------------------------------------------------
| Warable Screen Style  (https://yesviz.com/watches.php)            |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 319px) {
}
*/`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-tabs.css"],"names":[],"mappings":"AAAA;;;iEAAA;AAKA;EACI,yBAAA;EACA,uCAAA;EACA,kBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iDAAA;EACA,4CAAA;EACA,2CAAA;EACA,kCAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;AAAJ;;AAGA;;EAEI,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,6BAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AAAJ;;AAEA;EACI,yBAAA;EACA,gBAAA;EACA,4BAAA;EACA,6BAAA;EACA,mBAAA;AACJ;;AACA;EACI,yBAAA;EACA,wBAAA;EACA,4BAAA;EACA,gBAAA;EACA,4BAAA;EACA,6BAAA;EACA,mBAAA;AAEJ;;AAAA;;EAEI,gBAAA;EACA,4BAAA;EACA,6BAAA;EACA,mBAAA;AAGJ;;AAAA;EACI,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AAGJ;;AAAA;EACI,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AAGJ;;AAAA;EACI,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AAGJ;;AAAA;EACI,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AAGJ;;AAAA;EACI,mBAAA;EACA,mCAAA;EACA,iBAAA;AAGJ;;AAAA;EACI,YAAA;EACA,SAAA;EACA,6CAAA;EACA,wCAAA;EACA,2CAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;EACA,+BAAA;AAGJ;;AAAA;EACI,YAAA;EACA,SAAA;EACA,6CAAA;EACA,wCAAA;EACA,2CAAA;EACA,mCAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;EACA,+BAAA;AAGJ;;AAAA;EACI,aAAA;EACA,YAAA;EACA,SAAA;EACA,6CAAA;EACA,wCAAA;EACA,2CAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;EACA,+BAAA;AAGJ;;AAAA;EACI,6BAAA;EACA,mCAAA;EACA,iBAAA;EACA,mBAAA;AAGJ;;AAAA;EACI,YAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,kCAAA;EACA,kDAAA;AAGJ;;AAAA;EACI,gBAAA;EACA,aAAA;EACA,kCAAA;EACA,wBAAA;EACA,qBAAA;EACA,qBAAA;AAGJ;;AAAA;EACI,gBAAA;EACA,aAAA;EACA,+BAAA;EACA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;AAGJ;;AAAA;EACI,gBAAA;EACA,aAAA;EACA,2BAAA;EACA,wBAAA;EACA,sBAAA;EACA,oBAAA;EACA,oBAAA;EACA,iBAAA;AAGJ;;AAAA;;;EAGI,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,0CAAA;EACA,gCAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;AAGJ;;AAAA;;;EAGI,gBAAA;EACA,sCAAA;EACA,oCAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mDAAA;AAGJ;;AAAA;;;EAGI,cAAA;EACA,gBAAA;EACA,4BAAA;EACA,0CAAA;EACA,qCAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;AAGJ;;AAAA;;;EAGI,gBAAA;EACA,sCAAA;EACA,oCAAA;EACA,qCAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mDAAA;AAGJ;;AAAA;;;;;;;;;;;;;;EAcI,gBAAA;EACA,cAAA;EACA,sCAAA;EACA,sCAAA;EACA,iBAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mBAAA;EACA,kHACI;AAER;;AAGA;;;;;;;;;;;;;EAaI,gBAAA;EACA,cAAA;EACA,sCAAA;EACA,sCAAA;EACA,iBAAA;EACA,qCAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mBAAA;EACA,kHACI;AADR;;AAOA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| EzClocker Tab UX CSS Classes\r\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\n\r\n.ezTabContainer {\r\n    color: var(--ezFontColor);\r\n    background-color: var(--ezClockerWhite);\r\n    border-style: none;\r\n    padding: 4px;\r\n}\r\n\r\n.ezTabsContainer {\r\n    padding-top: 4px;\r\n    padding-left: 4px;\r\n    padding-right: 4px;\r\n    padding-bottom: 0;\r\n    /* --ezClockerBackground defined in ez-body.css */\r\n    background-color: var(--ezClockerBackground);\r\n    /* --ezClockerGray defined in ez-body.css */\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-top-width: 1px;\r\n    border-bottom-width: 0;\r\n    border-left-width: 1px;\r\n    border-right-width: 1px;\r\n}\r\n\r\n.ezTabs-tab-button,\r\n.ezTabs-tab-button:enabled {\r\n    margin: 0 4px 0 0;\r\n    min-height: 32;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: #000000;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    background-color: #c0c0c0;\r\n    outline-style: none;\r\n    color: #000000;\r\n    box-shadow: none;\r\n}\r\n.ezTabs-tab-button:hover {\r\n    background-color: #e0e0e0;\r\n    box-shadow: none;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    outline-style: none;\r\n}\r\n.ezTabs-tab-button:active {\r\n    background-color: #ffffff;\r\n    border-bottom-width: 2px;\r\n    border-bottom-color: #ffffff;\r\n    box-shadow: none;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    outline-style: none;\r\n}\r\n.ezTabs-tab-button:focus,\r\n.ezTabs-tab-button:focus:active {\r\n    box-shadow: none;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    outline-style: none;\r\n}\r\n\r\n.ezTabs-tab-button-active {\r\n    margin: 0 4px 0 0;\r\n    min-height: 32;\r\n    font-weight: bold;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: #6d6e70;\r\n    border-bottom-color: #ffffff;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    outline-style: none;\r\n    color: #000000;\r\n    background-color: #ffffff;\r\n    box-shadow: none;\r\n}\r\n\r\n.ezTabs-tab-button-active:HOVER {\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: #6d6e70;\r\n    border-bottom-color: #ffffff;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    outline-style: none;\r\n    color: #000000;\r\n    background-color: #ffffff;\r\n    box-shadow: none;\r\n}\r\n\r\n.ezTabs-tab-button-active:ACTIVE {\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: #6d6e70;\r\n    border-bottom-color: #ffffff;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    outline-style: none;\r\n    color: #000000;\r\n    background-color: #ffffff;\r\n    box-shadow: none;\r\n}\r\n\r\n.ezTabs-tab-button-active:FOCUS {\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: #6d6e70;\r\n    border-bottom-color: #ffffff;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    outline-style: none;\r\n    color: #000000;\r\n    background-color: #ffffff;\r\n    box-shadow: none;\r\n}\r\n\r\n.ez-tab-view-container {\r\n    border-style: solid;\r\n    border-color: var(--ezClockerBlack);\r\n    border-width: 2px;\r\n}\r\n\r\n.ezTabs-tab-view {\r\n    padding: 8px;\r\n    margin: 0;\r\n    /* --ezClockerSilver defined in ez-body.css */\r\n    background-color: var(--ezClockerSilver);\r\n    /* --ezClockerGray defined in ez-body.css */\r\n    border-color: var(--ezClockerGray);\r\n    border-width: 1px;\r\n    border-style: solid;\r\n    border-bottom-left-radius: 3px;\r\n    border-bottom-right-radius: 3px;\r\n}\r\n\r\n.ezTabs-tab-view-active {\r\n    padding: 8px;\r\n    margin: 0;\r\n    /* --ezClockerSilver defined in ez-body.css */\r\n    background-color: var(--ezClockerSilver);\r\n    /* --ezClockerGray defined in ez-body.css */\r\n    border-color: var(--ezClockerBlack);\r\n    border-width: 1px;\r\n    border-style: solid;\r\n    border-bottom-left-radius: 3px;\r\n    border-bottom-right-radius: 3px;\r\n}\r\n\r\n.ezTabs-tab-view-hidden {\r\n    display: none;\r\n    padding: 8px;\r\n    margin: 0;\r\n    /* --ezClockerSilver defined in ez-body.css */\r\n    background-color: var(--ezClockerSilver);\r\n    /* --ezClockerGray defined in ez-body.css */\r\n    border-color: var(--ezClockerGray);\r\n    border-width: 1px;\r\n    border-style: solid;\r\n    border-bottom-left-radius: 3px;\r\n    border-bottom-right-radius: 3px;\r\n}\r\n\r\n.ezTabs-content {\r\n    background-color: transparent;\r\n    border-color: var(--ezClockerBlack);\r\n    border-width: 1px;\r\n    border-style: solid;\r\n}\r\n\r\n.ezTabs-content-scroll-box {\r\n    padding: 8px;\r\n    overflow: auto;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: var(--ezClockerGray);\r\n    box-shadow: inset 0 0 1px 1px rgb(109 110 112 / 50%);\r\n}\r\n\r\n.ezTabs-section-grid-cols_360x360 {\r\n    margin-top: 10px;\r\n    display: grid;\r\n    grid-template-columns: 360px 360px;\r\n    justify-content: stretch;\r\n    align-content: center;\r\n    grid-column-gap: 16px;\r\n}\r\n\r\n.ezTabs-section-grid-cols_75x25 {\r\n    margin-top: 10px;\r\n    display: grid;\r\n    grid-template-columns: 75% auto;\r\n    grid-template-rows: auto;\r\n    justify-content: start;\r\n    align-content: center;\r\n    grid-column-gap: 8px;\r\n    grid-row-gap: 8px;\r\n}\r\n\r\n.ezTabs-section-grid-cols_100 {\r\n    margin-top: 10px;\r\n    display: grid;\r\n    grid-template-columns: 100%;\r\n    grid-template-rows: auto;\r\n    justify-content: start;\r\n    align-content: start;\r\n    grid-column-gap: 8px;\r\n    grid-row-gap: 8px;\r\n}\r\n\r\n.ezTab,\r\n.ezTab:enabled,\r\n.ezTab:visited {\r\n    min-height: 32px;\r\n    margin-bottom: 0;\r\n    color: var(--ezClockerBlack);\r\n    background-color: var(--ezClockerOffWhite);\r\n    border-color: var(--ezLightNavy);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-bottom-width: 0;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    border-top-left-radius: 3px;\r\n    border-top-right-radius: 3px;\r\n    outline-style: none;\r\n    outline-width: 0;\r\n}\r\n\r\n.ezTab:enabled:hover,\r\n.ezTab:enabled:active,\r\n.ezTab:enabled:focus {\r\n    margin-bottom: 0;\r\n    color: var(--ezNavyContainerTextColor);\r\n    background-color: var(--ezHoverNavy);\r\n    border-color: var(--ezClockerBlack);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-bottom-width: 0;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    border-top-left-radius: 3px;\r\n    border-top-right-radius: 3px;\r\n    outline-style: none;\r\n    outline-width: 0;\r\n    box-shadow: inset 0 -4px 4px -2px var(--ezDarkNavy);\r\n}\r\n\r\n.ezErrorTab,\r\n.ezErrorTab:enabled,\r\n.ezErrorTab:visited {\r\n    min-height: 32;\r\n    margin-bottom: 0;\r\n    color: var(--ezClockerBlack);\r\n    background-color: var(--ezClockerOffWhite);\r\n    border-color: var(--ezBorderAlertRed);\r\n    border-style: solid;\r\n    border-width: 2px;\r\n    border-bottom-width: 0;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    border-top-left-radius: 3px;\r\n    border-top-right-radius: 3px;\r\n    outline-style: none;\r\n    outline-width: 0;\r\n}\r\n\r\n.ezErrorTab:enabled:hover,\r\n.ezErrorTab:enabled:active,\r\n.ezErrorTab:enabled:focus {\r\n    margin-bottom: 0;\r\n    color: var(--ezNavyContainerTextColor);\r\n    background-color: var(--ezHoverNavy);\r\n    border-color: var(--ezBorderAlertRed);\r\n    border-style: solid;\r\n    border-width: 2px;\r\n    border-bottom-width: 0;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    border-top-left-radius: 3px;\r\n    border-top-right-radius: 3px;\r\n    outline-style: none;\r\n    outline-width: 0;\r\n    box-shadow: inset 0 -4px 4px -2px var(--ezDarkNavy);\r\n}\r\n\r\n.ezActiveTab,\r\n.ezActiveTab:hover,\r\n.ezActiveTab:visited,\r\n.ezActiveTab:focus,\r\n.ezActiveTab:active,\r\n.ezActiveTab:enabled,\r\n.ezActiveTab:enabled:hover,\r\n.ezActiveTab:enabled:visited,\r\n.ezActiveTab:enabled:active,\r\n.ezActiveTab:enabled:active:hover,\r\n.ezActiveTab:enabled:focus,\r\n.ezActiveTab:enabled:focus:hover,\r\n.ezActiveTab:enabled:focus:active,\r\n.ezActiveTab:enabled:focus:active:hover {\r\n    margin-bottom: 0;\r\n    min-height: 32;\r\n    background-color: var(--ezClockerNavy);\r\n    color: var(--ezNavyContainerTextColor);\r\n    font-weight: bold;\r\n    border-color: var(--ezClockerBlack);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-bottom-width: 0;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    border-top-left-radius: 3px;\r\n    border-top-right-radius: 3px;\r\n    outline-style: none;\r\n    box-shadow:\r\n        0 -2px 2px 0 rgb(109 110 112 / 50%),\r\n        2px 0 2px 0 rgb(109 110 112 / 50%),\r\n        -2px 0 2px 0 rgb(109 110 112 / 50%);\r\n}\r\n\r\n.ezErrorActiveTab,\r\n.ezErrorActiveTab:hover,\r\n.ezErrorActiveTab:visited,\r\n.ezErrorActiveTab:focus,\r\n.ezErrorActiveTab:enabled,\r\n.ezErrorActiveTab:enabled:hover,\r\n.ezErrorActiveTab:enabled:visited,\r\n.ezErrorActiveTab:enabled:active,\r\n.ezErrorActiveTab:enabled:active:hover,\r\n.ezErrorActiveTab:enabled:focus,\r\n.ezErrorActiveTab:enabled:focus:hover,\r\n.ezErrorActiveTab:enabled:focus:active,\r\n.ezErrorActiveTab:enabled:focus:active:hover {\r\n    margin-bottom: 0;\r\n    min-height: 32;\r\n    background-color: var(--ezClockerNavy);\r\n    color: var(--ezNavyContainerTextColor);\r\n    font-weight: bold;\r\n    border-color: var(--ezBorderAlertRed);\r\n    border-style: solid;\r\n    border-width: 2px;\r\n    border-bottom-width: 0;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    border-top-left-radius: 3px;\r\n    border-top-right-radius: 3px;\r\n    outline-style: none;\r\n    box-shadow:\r\n        0 -2px 2px 0 rgb(109 110 112 / 50%),\r\n        2px 0 2px 0 rgb(109 110 112 / 50%),\r\n        -2px 0 2px 0 rgb(109 110 112 / 50%);\r\n}\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 1023px) {\r\n}\r\n*/\r\n\r\n/* -------------------------------------------------------------------\r\n| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 768px) {\r\n}\r\n*/\r\n\r\n/* -------------------------------------------------------------------\r\n| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 480px) {\r\n}\r\n*/\r\n\r\n/* -------------------------------------------------------------------\r\n| Warable Screen Style  (https://yesviz.com/watches.php)            |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 319px) {\r\n}\r\n*/"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
